var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "113px",
    height: "113px",
    viewBox: "0 0 113 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rewards-(redeem-cash-success)",
    transform: "translate(-1217.000000, -163.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(1100.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(119.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 32.000000)",
    fill: "#26E3BA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00528093465,26.0069084 C0.0787081098,27.250538 0.898644899,28.2971571 2.08571756,28.6542389 L24.0649187,35.3402875 L24.8726176,50.5839859 C24.9093312,51.187331 25.3131806,51.7167971 25.8883602,51.9138077 C26.0474524,51.9753736 26.2187825,51.9999999 26.3778747,51.9999999 C26.8061999,51.9999999 27.2100493,51.8276156 27.503758,51.4951601 L35.2748007,42.8390051 L46.288877,50.5101069 C46.7783915,50.8548755 47.353571,51.039573 47.9532263,51.039573 C49.3361048,51.039573 50.5354153,50.0545198 50.829124,48.6754453 L59.9708073,1.79922576 C60.0809481,1.2574465 59.8729044,0.691040903 59.4568171,0.34627228 C59.0284919,-0.0108095083 58.4533124,-0.097001664 57.9393221,0.112322143 L1.76753314,23.1133146 C0.629411923,23.6304675 -0.0681462405,24.7632787 0.00528093465,26.0069084 Z M27.6628502,46.8038442 L27.1610979,37.1872623 L32.7905146,41.1028488 L27.6628502,46.8038442 Z M47.9042749,47.9735949 L27.858656,34.0104657 L55.9690263,6.65061281 L47.9042749,47.9735949 Z M52.8850849,5.44392263 L25.0928991,32.4959464 L3.13817374,25.8222109 L52.8850849,5.44392263 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#28EBC1",
    strokeWidth: 4,
    cx: 54.5,
    cy: 54.5,
    r: 54.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.e1de460f0de53f8e39e222416703651c.svg";
export { ForwardRef as ReactComponent };